import React from "react";
import {Spinner} from "react-bootstrap";

const Loading = () => {
    return (
        <div className={"d-flex ai-center jc-center h-100 w-100"}>
            <Spinner animation="border" variant="primary">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>

    );
};

export default Loading;